/**
 * Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
export enum UploaderType {
    FILE,
    CAMERA,
}

export interface SelectUploaderPayload {
    uploader: UploaderType;
}

export interface UploaderStateModel {
    uploader: UploaderType;
}

export interface FileUploadDialogData {
    form: string;
    key: any;
    layer: string;
    accept: string;
    maxFiles: number;
}
